import Layout from '@4c/layout';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Text from './Text';
const styles = require('./Tooltip-styles.module.scss');
const propTypes = {
  /** Controls placement of tooltip in relation to its target. */
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  // TODO: maybe revise this?
  variant: PropTypes.oneOf(['default', 'subscription'])
};

function Tooltip({
  id,
  tooltip,
  placement,
  variant = 'default',
  enabled = true,
  children,
  className
}) {
  if (!enabled) {
    return React.createElement(React.Fragment, null, children);
  }

  return React.createElement(OverlayTrigger, {
    trigger: ['hover', 'focus'],
    placement: placement,
    delay: {
      show: 250,
      hide: 400
    },
    overlay: React.createElement(Layout, {
      id: id,
      role: "tooltip",
      inline: true,
      justify: "center",
      className: classNames(className, styles.tooltip, variant === 'subscription' && styles.subscriptionTooltip)
    }, React.createElement(Text, {
      color: "headline",
      variant: "sm"
    }, tooltip))
  }, children);
}

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = propTypes;
export default Tooltip;